"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[192],{

/***/ 38579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos'));

/***/ }),

/***/ 88710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57833);
/* harmony import */ var shared_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41210);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow: auto;\n  display: flex;\n  gap: ",
        "px;\n  margin: 0 auto;\n\n  ",
        " {\n    /* Hide scrollbar for Chrome, Safari and Opera */\n    ::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* Hide scrollbar for IE, Edge and Firefox */\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 50px;\n  height: 50px;\n  background-color: white;\n  border-color: white;\n  transform: ",
        ";\n\n  ",
        " {\n    width: 55px;\n    height: 55px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: ",
        "px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      left: ",
        "px;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      right: ",
        "px;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      bottom: ",
        "px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      top: 0;\n      bottom: 0;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  display: none;\n  z-index: 11;\n  right: ",
        ";\n  left: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n  \n  display: flex;\n  align-items: center;\n\n  ",
        " {\n    display: block;\n    padding: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  ",
        " {\n    display: block;\n    width: 88px;\n    height: 100%;\n    right: ",
        ";\n    left: ",
        ";\n    top: 0;\n    position: absolute;\n    pointer-events: none;\n    bottom: 0;\n    z-index: 10;\n    background: linear-gradient(\n      270deg,\n      #ffffff 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var DEFAULT_SCROLL_AMOUNT_IN_PIXEL = 300;
var FullWidthSlider = function(_param) {
    var children = _param.children, _scrollAmount = _param.scrollAmount, scrollAmount = _scrollAmount === void 0 ? DEFAULT_SCROLL_AMOUNT_IN_PIXEL : _scrollAmount, scrollButtonOffset = _param.scrollButtonOffset, _gap = _param.gap, gap = _gap === void 0 ? 3 : _gap, wrapperBoxProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "children",
        "scrollAmount",
        "scrollButtonOffset",
        "gap"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isScrollable = ref1[0], setScrollable = ref1[1];
    var ref2 = (0,shared_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)(), windowWidth = ref2.width;
    var buttonTopOffset = scrollButtonOffset && "top" in scrollButtonOffset && scrollButtonOffset.top;
    var buttonBottomOffset = scrollButtonOffset && "bottom" in scrollButtonOffset && scrollButtonOffset.bottom;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref1, ref2, ref3;
        var isCurrentlyScrollable = (ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight) ? ((ref2 = ref.current) === null || ref2 === void 0 ? void 0 : ref2.scrollWidth) > ((ref3 = ref.current) === null || ref3 === void 0 ? void 0 : ref3.clientWidth) : true;
        setScrollable(isCurrentlyScrollable);
    }, [
        windowWidth
    ]);
    var createScrollHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(direction) {
        return function() {
            var element = ref.current;
            if (!element) {
                return;
            }
            var scrollLeft = element.scrollLeft;
            element.scrollTo({
                left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
                behavior: "smooth"
            });
        };
    }, [
        scrollAmount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        position: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhiteFade, {
                position: "left"
            }),
            isScrollable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButtonWrapper, {
                bottom: buttonBottomOffset || 0,
                top: buttonTopOffset || 0,
                position: "left",
                left: 0,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
                    direction: "left",
                    onClick: createScrollHandler("left")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollableSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                justifyContent: isScrollable ? "start" : "center",
                px: 2,
                gap: gap,
                ref: ref
            }, wrapperBoxProps), {
                children: children
            })),
            isScrollable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButtonWrapper, {
                bottom: buttonBottomOffset || 0,
                top: buttonTopOffset || 0,
                right: 0,
                position: "right",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ScrollButton, {
                    direction: "right",
                    onClick: createScrollHandler("right")
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WhiteFade, {
                position: "right"
            })
        ]
    });
};
var ScrollableSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? gap * 8 : 0;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var ScrollButton = function(param) {
    var onClick = param.onClick, direction = param.direction;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CircularButton, {
        flip: direction === "left",
        variant: "tertiary",
        rounded: true,
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
    });
};
var CircularButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Button)(_templateObject1(), function(param) {
    var flip = param.flip;
    return flip && "rotate(-180deg)";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var ScrollButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject7(), function(param) {
    var position = param.position;
    return position === "right" ? "-80px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "-80px" : "none";
}, function(param) {
    var top = param.top;
    return top && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2(), top);
}, function(param) {
    var left = param.left;
    return (left !== null || left !== undefined) && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), left);
}, function(param) {
    var right = param.right;
    return (right !== null || right !== undefined) && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), right);
}, function(param) {
    var bottom = param.bottom;
    return bottom && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5(), bottom);
}, function(param) {
    var top = param.top, bottom = param.bottom;
    return !bottom && !top && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6());
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0, 4);
});
var WhiteFade = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var position = param.position;
    return position === "right" ? "-60px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "-60px" : "none";
}, function(param) {
    var position = param.position;
    return position === "left" ? "rotate(-180deg)" : "none";
});
/* harmony default export */ __webpack_exports__["Z"] = (FullWidthSlider);


/***/ }),

/***/ 41210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useWindowSize = function() {
    var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 20;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)( true ? {
        width: window.innerWidth,
        height: window.innerHeight
    } : 0), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var resizeTimeout;
        var handleResize = function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }, delay);
        };
        window.addEventListener("resize", handleResize);
        return function() {
            clearTimeout(resizeTimeout);
            window.removeEventListener("resize", handleResize);
        };
    }, [
        delay
    ]);
    return windowSize;
};


/***/ }),

/***/ 59593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 158%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #76a334;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: inherit;\n  color: inherit;\n  width: ",
        "px;\n\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.9);\n    transform: scale(1.1);\n  }\n\n  &:hover .card-title {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: hidden;\n  position: relative;\n  width: 280px;\n  height: 210px;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  right: ",
        "px;\n  padding: ",
        ";\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var CARD_WIDTH = 280;
function ImageCard(param) {
    var href = param.href, ctaHighlight = param.ctaHighlight, cta = param.cta, imageSrc = param.imageSrc, pillText = param.pillText, _ctaTextAlign = param.ctaTextAlign, ctaTextAlign = _ctaTextAlign === void 0 ? "center" : _ctaTextAlign;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)("dynamic_landing_page").t;
    var WrapperComponent = href ? (next_link__WEBPACK_IMPORTED_MODULE_5___default()) : react__WEBPACK_IMPORTED_MODULE_2__.Fragment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapperComponent, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledLink, {
            target: "_blank",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageWrapper, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                alt: "",
                                src: imageSrc,
                                objectFit: "cover",
                                width: CARD_WIDTH,
                                height: 210
                            })
                        }),
                        pillText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPill, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                                lineHeight: 1,
                                variant: "caption",
                                textAlign: true,
                                children: pillText
                            })
                        })
                    ]
                }),
                cta ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    pt: 1.5,
                    textAlign: ctaTextAlign,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TypographyCTA, {
                            component: "span",
                            className: "card-title",
                            children: cta ? cta : t("CTA")
                        }),
                        ctaHighlight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TypographyCompany, {
                            className: "card-title",
                            component: "span",
                            children: [
                                " ",
                                ctaHighlight
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
}
var TypographyCTA = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography)(_templateObject());
var TypographyCompany = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(TypographyCTA)(_templateObject1());
var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].a(_templateObject2(), CARD_WIDTH);
var ImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div(_templateObject3(), function(props) {
    return props.theme.spacing(1.5);
});
var StyledPill = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject4(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5, 1);
}, function(props) {
    return props.theme.spacing(8);
});
/* harmony default export */ __webpack_exports__["Z"] = (ImageCard);


/***/ }),

/***/ 73743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_components_FullWidthSlider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88710);
/* harmony import */ var static_pages_components_ImageCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59593);




var ImageCardSlider = function(param) {
    var items = param.items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components_FullWidthSlider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        scrollButtonOffset: {
            top: 80
        },
        children: items.map(function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(static_pages_components_ImageCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                href: item.href,
                cta: item.cta,
                ctaHighlight: item.ctaHighlight,
                pillText: item.pillText,
                imageSrc: item.imageSrc,
                ctaTextAlign: item.ctaTextAlign
            }, item.key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageCardSlider);


/***/ }),

/***/ 40192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ ImageGalleryWithCaption; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74129);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var static_pages_components_ImageCardSlider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73743);





function ImageGalleryWithCaption(param) {
    var title = param.title, caption = param.caption, _images = param.images, images = _images === void 0 ? [] : _images, ctaTitle = param.ctaTitle, ctaLink = param.ctaLink;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
        maxWidth: 1050,
        mx: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
            textAlign: "center",
            py: 3,
            px: 2,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                    variant: "h3",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Typography, {
                    varaint: "body2",
                    children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_2__/* .documentToReactComponents */ .h)(caption)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(static_pages_components_ImageCardSlider__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        items: images.map(function(param, index) {
                            var fields = param.fields;
                            var ref, ref1, ref2;
                            var image = fields.image, link = fields.link, title = fields.title;
                            var backgroundImage = (image === null || image === void 0 ? void 0 : (ref = image.fields) === null || ref === void 0 ? void 0 : ref.file) ? "https:".concat((ref1 = image.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url, "?w=400") : "";
                            return {
                                key: index,
                                href: link || "",
                                cta: title,
                                imageSrc: backgroundImage,
                                pillText: "",
                                ctaTextAlign: "left"
                            };
                        })
                    })
                }),
                ctaLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                    my: 3,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Button, {
                        varaint: "primary",
                        href: ctaLink,
                        target: "_blank",
                        children: ctaTitle
                    })
                }) : null
            ]
        })
    });
}


/***/ })

}]);